<script setup lang="ts">
import type AvailableIcons from '@/interfaces/AvailableIcons';
import ConnxButton, { ButtonStyles } from './Buttons/ConnxButton.vue';
import ConnxActionButton from './Buttons/ConnxActionButton.vue';
type ButtonType = 'button' | 'submit' | 'reset';

export interface ButtonAction {
  icon?: AvailableIcons;
  text: string;
  class?: string;
  action: () => void;
}

type IconPosition = 'before' | 'after';

interface Props {
  type?: ButtonType;
  link?: string | null;
  icon?: AvailableIcons | null;
  disabled?: boolean;
  active?: boolean;
  iconClass?: String | null;
  iconPosition?: IconPosition | null;
  buttonStyle?: ButtonStyles;
  actions?: ButtonAction[];
  dropdownClass?: string;
  dropdownContainerClass?: string;
  dropdownPosition?: 'top' | 'bottom' | 'bottom-left';
  buttonSize?: 'sm' | 'md' | 'lg';
}

const props = defineProps<Props>();
</script>
<template>
  <component :is="actions ? ConnxActionButton : ConnxButton" v-bind="props">
    <slot />
    <template v-for="(_, name) in $slots" v-slot:[name]="slotProps">
      <slot :name="name" v-bind="slotProps" />
    </template>
  </component>
</template>
